import React from 'react';
import {
  Typography,
  Grid,
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import { Organization } from '../../../types/generated-types';
import BorderedSection from '../shared/borderedSection';

import '../plm/ui/plm.css';
interface OrganizationDetailViewerProps {
  organization?: Partial<Organization>;
  loading?: boolean;
  error?: Error;
}
export default function InteractiveList() {
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
}

export const OrganizationDetailViewer: React.FC<
  OrganizationDetailViewerProps
> = ({ organization, loading, error }) => {
  if (loading) {
    return (
      <Box
        component="div"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        <Box sx={{ marginBottom: '2rem' }}>
          <CircularProgress color="secondary" size="3rem" />
        </Box>
        <Box>
          <Typography variant="h4" color="secondary">
            Preparing your data...
          </Typography>
        </Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Typography color="error">
          Error loading organization: {error.message}
        </Typography>
      </Box>
    );
  }

  if (!organization) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Typography>No organization found</Typography>
      </Box>
    );
  }

  return (
    <Grid className="item-wrapper" xs={12}>
      <BorderedSection
        title="Organization Information"
        // icon={() => <Business />}
        ccStyle={{ margin: '4px' }}
      >
        <Grid container className="plm-inner-grid-container">
          <Grid className="item-wrapper" xs={12}>
            <List className="plm-ul" dense={false}>
              <ListItem>
                <b>Name:</b>
                <ListItemText
                  className="plm-listItem-text"
                  primary={organization.name}
                />
              </ListItem>
              <ListItem>
                <b>Description:</b>
                {organization.description && (
                  <ListItemText
                    className="plm-listItem-text"
                    primary={organization.description}
                  />
                )}
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </BorderedSection>

      <Grid className="item-wrapper" xs={12}>
        <BorderedSection
          title="Headquarters Address"
          // icon={() => <LocationOn />}
        >
          <Grid container className="plm-inner-grid-container">
            <Grid className="item-wrapper" xs={12}>
              <List className="plm-ul" dense={false}>
                <ListItem>
                  <Typography className="label">Address Line 1:</Typography>
                  <ListItemText
                    className="plm-listItem-text"
                    primary={organization.hqAddress?.line1}
                  />
                </ListItem>
                <ListItem>
                  <Typography className="label">Address Line 2:</Typography>
                  <ListItemText
                    className="plm-listItem-text"
                    primary={organization.hqAddress?.line2}
                  />
                </ListItem>
                <ListItem>
                  <b>City:</b>
                  <ListItemText
                    className="plm-listItem-text"
                    primary={organization.hqAddress?.city}
                  />
                </ListItem>
                <ListItem>
                  <b>State:</b>
                  <ListItemText
                    className="plm-listItem-text"
                    primary={organization.hqAddress?.state}
                  />
                </ListItem>
                <ListItem>
                  <b>Postal Code:</b>
                  <ListItemText
                    className="plm-listItem-text"
                    primary={organization.hqAddress?.postalCode}
                  />
                </ListItem>
                <ListItem>
                  <b>Country:</b>
                  <ListItemText
                    className="plm-listItem-text"
                    primary={organization.hqAddress?.country}
                  />
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </BorderedSection>
      </Grid>

      <Grid className="item-wrapper" xs={12}>
        <BorderedSection
          title="Contact Information"
          // icon={() => <Phone />}
        >
          <Grid container className="plm-inner-grid-container">
            <Grid className="item-wrapper" xs={12}>
              <List className="plm-ul" dense={false}>
                <ListItem>
                  <b>Phone:</b>
                  <a href={`tel:${organization.hqPhone}`}>
                    <ListItemText
                      className="plm-listItem-text"
                      primary={organization.hqPhone}
                    />
                  </a>
                </ListItem>
                <ListItem>
                  <b>Email:</b>
                  <a
                    className="plm-email"
                    href={`mailto:${organization.hqEmail}`}
                  >
                    <ListItemText
                      className="plm-listItem-text"
                      primary={organization.hqEmail}
                    />
                  </a>
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </BorderedSection>
      </Grid>

      {organization.parentOrganization && (
        <Grid className="item-wrapper" xs={12}>
          <BorderedSection
            title="Parent Organization"
            // icon={() => <AccountTree />}
          >
            <Grid container className="plm-inner-grid-container">
              <Grid className="item-wrapper" xs={12}>
                <List className="plm-ul" dense={false}>
                  <ListItem>
                    <b>Parent Organization:</b>
                    <ListItemText
                      className="plm-listItem-text"
                      primary={organization.parentOrganization.name}
                    />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </BorderedSection>
        </Grid>
      )}
    </Grid>
  );
};
